import { gql } from '@apollo/client';

export const UPSERT_SERVICE = gql`
  mutation UpsertService($input: UpsertServiceInput!) {
    service: upsertService(input: $input) {
      id
    }
  }
`;
